import React, { useContext } from "react";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";

import { useState } from "react";
import LanguageContext from "../../components/Language/LanguageContext";

const Pricing = () => {
  const { messages } = useContext(LanguageContext);
  const [isYearly, setIsYearly] = useState(true);

  // Harga berdasarkan tipe interval
  const premiumPrice = isYearly ? 384000 : 480000;
  const formattedPrice = new Intl.NumberFormat("id-ID").format(premiumPrice);

  return (
    <>
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 " id="Pricing">
        <header className="flex align-items-center justify-content-center flex-column gap-2">
          {/* <h1 className="m-0 font-semibold text-lg line-height-3 text-primary-500">
            PRICING
          </h1> */}
          <h1 className="font-bold  text-900 text-center text-4xl">
            {messages.JudulPricing}
          </h1>
          {/* <p className="text-xl line-height-3 text-700 mt-0 mb-0">
            Fringilla ut morbi tincidunt augue interdum velit euismod. Non arcu
            risus quis varius quam.
          </p> */}
          <div className=" align-items-center">
            <span className="font-semibold mr-3 pricing2">
              {messages.BilledMonthlyPricing}
            </span>

            <InputSwitch
              checked={isYearly}
              onChange={(e) => setIsYearly(e.value)}
              // style={{ zIndex: "999" }}
              className="pricing4"
            />
            <span className="font-semibold  prici1 text-center">
              {messages.BilledYearlyPricing}{" "}
              <span
                className="font-bold prici2"
                style={{ fontSize: "20px", color: "blue" }}
              >
                {messages.BilledSavePricing}
              </span>
            </span>
          </div>
        </header>
        <div className="overflow-x-auto mt-7">
          <table
            className="w-full white-space-nowrap"
            style={{ borderCollapse: "collapse", borderSpacing: "0" }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f5f5f5" }}>
                <td className="surface-100 p-3">
                  <div className="text-3xl text-900 mb-2">
                    {messages.BerlanggananPricing}
                  </div>
                  <span className="text-600 line-height-3">
                    {messages.SubscriptionPricing}
                  </span>
                </td>
                <td className="surface-100 p-3 text-center">
                  <div className="text-900 text-xl font-medium mb-3">
                    {messages.freeJudul}
                  </div>
                  <div className="text-600 mb-3">
                    <span className="text-3xl text-900">Rp.0</span>{" "}
                    {messages.MonthPricing}
                  </div>
                  <a href="">
                    <Button
                      className="p-button-rounded"
                      // label={messages.FreeTrialPricing}
                    />
                  </a>
                </td>
                <td className="surface-100 p-3 text-center">
                  <div className="text-900 text-xl font-medium mb-3">
                    Basic
                  </div>
                  <div className="text-600 mb-3">
                    <span className="text-3xl text-900">
                      Rp.{formattedPrice}
                    </span>{" "}
                    {messages.MonthPricing}
                  </div>
                  <a href="https://app.smartsafetee.com/auth/login">
                    <Button
                      className="p-button-rounded"
                      label={messages.BuyNowPricing}
                    />
                  </a>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.JumlahPricing}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.tigaPenggunaPricing}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.sepuluhPenggunaPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.InsidenPricing}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.TigaGambarPricing}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.ManajerPricing}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.DokumenPricing}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.IdentifikasiPricing}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.NumberHazardPricing}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.HazardAktivitas}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.NumberAktivitas}
                </td>
                <td className="text-center text-900 border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.AsetPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.NumberAset}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.VendorPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.NumberVendor}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.KaryawanPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.NumberKaryawan}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.JenisDokumenPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  <i className=" pi pi-check" style={{ color: "#22c8a7" }}></i>
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  <i className=" pi pi-check" style={{ color: "#22c8a7" }}></i>
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.DepartementPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  <i className=" pi pi-check" style={{ color: "#22c8a7" }}></i>
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  <i className=" pi pi-check" style={{ color: "#22c8a7" }}></i>
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.KalenderPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  <i className="pi pi-times" style={{ color: "#fe3d32" }}></i>
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  <i className=" pi pi-check" style={{ color: "#22c8a7" }}></i>
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.InspeksiPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.templatePricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.InspeksiAssetsPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.templatePricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.IzinKerjaPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.templatePricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.PenyimpananPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  5 GB
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  500 GB
                </td>
              </tr>
              <tr>
                <td className="p-3 text-900 font-medium border-bottom-1 border-400">
                  {messages.RiwayatBuktiPricing}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.TigaTahun}
                </td>
                <td className="text-center text-900 p-medium border-bottom-1 border-400">
                  {messages.UnlimitedPricing}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="surface-section px-4 py-2 md:px-6 lg:px-8 ">
        <article className="flex flex-column gap-4 p-4 surface-0 border-round-lg shadow-2">
          <div className="flex flex-wrap justify-content-between align-items-center surface-border pb-4 gap-5">
            {/* Bagian Kiri */}
            <div className="flex flex-column gap-2">
              <h3 className="m-0 font-semibold text-xl text-900">
                {messages.AdditionalPricing}
              </h3>
              <p className="mt-0 mb-0 text-semibold text-900 text-xl">
                {messages.AdditionalPricing1} {""}
                <span className="text-900 font-semibold text-xl">
                  Rp.
                  {new Intl.NumberFormat("id-ID").format(
                    isYearly ? 38400 : 48000
                  )}
                  {messages.AdditionalPricing2}
                </span>
              </p>
            </div>

            {/* Bagian Kanan */}
            <div className="flex flex-column gap-2">
              <span className="font-semibold text-xl text-900">
                {messages.AdditionalPricing3}
              </span>{" "}
              <ul className="list-none mt-0 mb-0 sm:mt-2 p-0">
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i
                      className="pi pi-check-circle  mr-2"
                      style={{ color: "#22c8a7" }}
                    ></i>
                    {messages.AdditionalPricing4}
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i
                      className="pi pi-check-circle mr-2"
                      style={{ color: "#22c8a7" }}
                    ></i>
                    {messages.AdditionalPricing5}
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i
                      className="pi pi-check-circle mr-2"
                      style={{ color: "#22c8a7" }}
                    ></i>
                    {messages.AdditionalPricing6}
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i
                      className="pi pi-check-circle mr-2"
                      style={{ color: "#22c8a7" }}
                    ></i>
                    {messages.AdditionalPricing7}
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-900 flex align-items-center">
                    <i
                      className="pi pi-check-circle mr-2"
                      style={{ color: "#22c8a7" }}
                    ></i>
                    {messages.AdditionalPricing8}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </article>
        {/* <div
          className="absolute top-50 w-screen"
          style={{ transform: "rotate(-6deg)" }}>
          <div className="h-4rem bg-primary-500"></div>
          <div className="h-4rem bg-primary-300"></div>
          <div className="h-4rem bg-primary-100"></div>
        </div> */}
      </div>
    </>
  );
};

export default Pricing;
